import React, { useState } from 'react';
import { omit } from 'lodash';
import { Stack } from '@mui/material';
import AttribsFields from '../theme/forms/AttribsFields';
import ScriptEditSidebarForm from './ScriptEditSidebarForm';

const VoterLookupForm = ({ element, attribsField, onSubmit, onCancel, onDeleteElement }) => {
  const [formData, setFormData] = useState({ paths: [], connectors: [], attribs: {}, ...element });

  function submit() {
    onSubmit(omit(formData, ['paths']));
  }

  const handleAttribsChange = (attribs) => {
    const next =
      attribs.check_prior_voter_selection === false
        ? { ...attribs, allow_selection_of_prior_selected_voter: false }
        : attribs;
    setFormData({ ...formData, attribs: next });
  };

  return (
    <ScriptEditSidebarForm
      title="Add a Voter Lookup element"
      iconClass="fa fa-random"
      displayName={formData.display_name || ''}
      onDisplayNameChange={(val) => setFormData({ ...formData, display_name: val })}
      prompt={formData.prompt || ''}
      onPromptChange={(val) => setFormData({ ...formData, prompt: val })}
      onSubmit={submit}
      onCancel={onCancel}
      onDeleteElement={onDeleteElement}
      showDelete
    >
      {!!attribsField && (
        <Stack spacing={1.25}>
          <AttribsFields
            fields={attribsField}
            value={formData.attribs}
            onChange={handleAttribsChange}
          />
        </Stack>
      )}
    </ScriptEditSidebarForm>
  );
};

export default VoterLookupForm;
